import { StatusLabel, StatusLabelTypes } from '@factorialco/deprecated-design-system'
import { F0TagStatus, StatusVariant } from '@factorialco/f0-react'
import { DocumentsSignatureStatusEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { documentSignatureStatusLabel } from 'modules/documents/lib/Documents'

interface Props {
  status: DocumentsSignatureStatusEnum
  useF0?: boolean
}

const statusToStatusLabelType: Record<DocumentsSignatureStatusEnum, StatusLabelTypes> = {
  ['pending']: 'warning',
  ['partially_signed']: 'info',
  ['completed']: 'positive',
  ['declined']: 'critical',
  ['bounced_email']: 'critical',
  ['cancelled']: 'neutral',
  ['error']: 'critical',
  ['expired']: 'critical',
}

const statusToF0Variant: Record<DocumentsSignatureStatusEnum, StatusVariant> = {
  ['pending']: 'warning',
  ['partially_signed']: 'info',
  ['completed']: 'positive',
  ['declined']: 'critical',
  ['bounced_email']: 'critical',
  ['cancelled']: 'neutral',
  ['error']: 'critical',
  ['expired']: 'critical',
}

const SignatureStatusTag = ({ status, useF0 }: Props) => {
  if (useF0) {
    return (
      <F0TagStatus
        text={documentSignatureStatusLabel(status)}
        variant={statusToF0Variant[status]}
      />
    )
  }

  return (
    <StatusLabel ellipsis type={statusToStatusLabelType[status]}>
      {documentSignatureStatusLabel(status)}
    </StatusLabel>
  )
}

export default observer(SignatureStatusTag)
